import { useMemo, useRef } from "react";
import { useForm } from "react-hook-form";
import HeiCheckbox from "../../../../Common/components/Form/HeiCheckbox/HeiCheckbox";
import HeiGrid from "../../../../Common/components/HeiGrid/HeiGrid";
import usePageTitle from "../../../../Common/hooks/usePageTitle";
import { defaultSorting } from "../../api/models/defaultSorting";
import { useMyProjectsGrid } from "../../hooks/useMyProjectsGrid";
import styles from "../../views/ProjectList.module.scss";
import { getColumns } from "./getMyProjectsGridColumns";
import { useSelector } from "react-redux";
import { selectHeiUser } from "../../../../Auth/store/accountSlice";
import { IFilteringModel } from "../../../../Common/models/grid";
import { SettingsKeys } from "../../../../Common/models/storageSettingsKeys";

const MyProjectsGrid = () => {
  usePageTitle("My Projects");
  const { fetchGridData } = useMyProjectsGrid();
  const callForceRefresh = useRef(null);
  const columns = getColumns(callForceRefresh);
  const heiUser = useSelector(selectHeiUser);

  const isAdmin = useMemo(
    () => heiUser.roles.some((r) => r === "Admin"),
    [heiUser]
  );

  const archivedForm = useForm({
    defaultValues: { withArchived: false },
    mode: "onChange",
  });
  const withArchived = archivedForm.watch("withArchived");
  const filteringModel = useMemo<IFilteringModel>(
    () => ({
      filters: [
        {
          column: "WithArchived",
          operator: "=",
          value: `${withArchived}`,
        },
      ],
    }),
    [withArchived]
  );

  return (
    <div className={styles.view}>
      {isAdmin && (
        <div className={styles.archivedCheckbox}>
          <HeiCheckbox
            control={archivedForm.control}
            label="Include archived"
            name={"withArchived"}
          ></HeiCheckbox>
        </div>
      )}
      <HeiGrid
        columns={columns}
        fetchGridData={fetchGridData}
        searchPlaceholder="Search project name, team members, cost center"
        defaultSorting={defaultSorting}
        refFunction={callForceRefresh}
        filtering={filteringModel}
        storageSettingsKey={SettingsKeys.ProjectsGrid}
      />
    </div>
  );
};

export default MyProjectsGrid;
